import { defineMessages } from 'react-intl';

export default defineMessages({
  otherCommentsTitle: {
    id: 'frontbucket.pullRequest.otherCommentsDialogTitle',
    description: 'Title for the other comments dialog',
    defaultMessage: 'Comments on other versions',
  },
  subtitleGlobal: {
    id: 'frontbucket.pullRequest.commentsDialogSubtitleGlobal',
    description: 'Description of who made a global comment on the pull request',
    defaultMessage: '{name} commented',
  },
  subtitleFile: {
    id: 'frontbucket.pullRequest.commentsDialogSubtitleFile',
    description: 'Description of who commented on the file',
    defaultMessage: '{name} commented on a file',
  },
  subtitleFileCommitRange: {
    id: 'frontbucket.pullRequest.commentsDialogSubtitleFileCommitRange',
    description: 'Commit range of file that was commented on',
    defaultMessage: 'in commit range {range}',
  },
  subtitleFileName: {
    id: 'frontbucket.pullRequest.commentsDialogSubtitleFileName',
    description: 'Description of who commented on which file',
    defaultMessage: '{name} commented on {filename}',
  },
  subtitleTask: {
    id: 'frontbucket.pullRequest.commentsDialogSubtitleTask',
    description: 'Description of who created a task on the pull request',
    defaultMessage: '{name} added tasks',
  },
  discardCommentsModalBody: {
    id: 'frontbucket.pullRequest.outdatedCommentsDialogDiscardWarning',
    description:
      'Body text of a confirmation dialog. Explains that unsaved comments will be lost upon closing the "outdated comments" modal.',
    defaultMessage:
      'Closing the {outdatedCommentsDialogTitle} dialog discards your unsaved comments.',
  },
  fileHeaderLozenge: {
    id: 'frontbucket.pullRequest.outdatedCommentsDialogFileHeaderLozenge',
    description:
      'Text for the lozenge in the file header of the outdated comments dialog',
    defaultMessage: 'Outdated',
  },
  reviewTitleComments: {
    id: 'frontbucket.pullRequest.reviewDraftDialog.title.comments',
    description:
      'Text for the title in the review draft dialog when only pending comments are created',
    defaultMessage: 'All pending comments',
  },
  reviewTitleTasks: {
    id: 'frontbucket.pullRequest.reviewDraftDialog.title.tasks',
    description:
      'Text for the title in the review draft dialog when only pending tasks are created',
    defaultMessage: 'All pending tasks',
  },
  reviewTitleBoth: {
    id: 'frontbucket.pullRequest.reviewDraftDialog.title.both',
    description:
      'Text for the title in the review draft dialog when both pending comments and tasks are created',
    defaultMessage: 'All pending comments and tasks',
  },
  reviewDialogCloseButton: {
    id: 'frontbucket.pullRequest.reviewDraftDialog.closeButton',
    description: 'Text for the close button in the review draft dialog',
    defaultMessage: 'Close',
  },
});
